import ReactTooltip from "react-tooltip";
import { useState } from "react";
import EdajMap from "./EdajMap";

const WorldMap = () => {
  const [content, setContent] = useState("");

  return (
    <>
      <div id="world" className="text-center">
        <div className="container">
          <div className="section-title">
            <h2>Autour du monde</h2>
          </div>
          <div style={{ marginRight: 0, marginLeft: 0 }}>
            <EdajMap setTooltipContent={setContent} />
            <ReactTooltip backgroundColor="transparent" padding="0">
              {content}
            </ReactTooltip>
          </div>
        </div>
      </div>
    </>
  );
};

export default WorldMap;
